module.exports = __webpack_public_path__ + "img/Uruguay.242e1a44.png";